import React, { MouseEventHandler } from 'react';

import IconArrowRight from './IconArrowRight';

import styles from './MenuPrimary.module.scss';

interface MenuPrimaryProps {
  children: string;
  handleClick: MouseEventHandler<HTMLButtonElement>;
  icon?: React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  showArrow?: boolean;
}

function MenuPrimary({ children, handleClick, icon: Icon, showArrow = false }: MenuPrimaryProps) {
  return (
    <button className={styles.menuPrimaryBtn} onClick={handleClick} type="button">
      <div className={styles.iconWrapper}>
        {Icon && <Icon />}
        <div className={styles.textWrapper}>
          <p className={styles.menuPrimaryLabel}>{children}</p>
        </div>
      </div>
      {showArrow && <IconArrowRight className={styles.arrowIcon} />}
    </button>
  );
}

export default MenuPrimary;
